import i18n from '@/locales';
import { nationAreaCode } from './nation-area-code';

// 中文国家名称到拼音首字母的映射表
const pinyinFirstLetterMap = {
	'中国': 'Z',
	'香港': 'X',
	'澳门': 'A',
	'台湾': 'T',
	'美国': 'M',
	'英国': 'Y',
	'日本': 'R',
	'澳大利亚': 'A',
	'加拿大': 'J',
	'阿尔巴尼亚': 'A',
	'阿尔及利亚': 'A',
	'阿富汗': 'A',
	'阿根廷': 'A',
	'爱尔兰': 'A',
	'埃及': 'A',
	'埃塞俄比亚': 'A',
	'爱沙尼亚': 'A',
	'阿拉伯联合酋长国': 'A',
	'阿鲁巴': 'A',
	'阿曼': 'A',
	'安道尔': 'A',
	'安哥拉': 'A',
	'安圭拉': 'A',
	'阿提瓜和巴布达': 'A',
	'奥地利': 'A',
	'阿塞拜疆': 'A',
	'巴巴多斯': 'B',
	'巴布亚新几内亚': 'B',
	'巴哈马': 'B',
	'白俄罗斯': 'B',
	'百慕大': 'B',
	'巴基斯坦': 'B',
	'巴拉圭': 'B',
	'巴林': 'B',
	'巴拿马': 'B',
	'保加利亚': 'B',
	'巴西': 'B',
	'北马里亚纳群岛': 'B',
	'贝宁': 'B',
	'比利时': 'B',
	'冰岛': 'B',
	'博茨瓦纳': 'B',
	'波多黎各': 'B',
	'波兰': 'B',
	'玻利维亚': 'B',
	'伯利兹': 'B',
	'波斯尼亚和黑塞哥维那': 'B',
	'不丹': 'B',
	'布基纳法索': 'B',
	'布隆迪': 'B',
	'朝鲜': 'C',
	'赤道几内亚': 'C',
	'丹麦': 'D',
	'德国': 'D',
	'东帝汶': 'D',
	'多哥': 'D',
	'多尼米加共和国': 'D',
	'多米尼克': 'D',
	'俄罗斯': 'E',
	'厄瓜多尔': 'E',
	'厄立特里亚': 'E',
	'法国': 'F',
	'法罗群岛': 'F',
	'梵蒂冈': 'F',
	'法属波利尼西亚': 'F',
	'法属圣马丁': 'F',
	'菲律宾': 'F',
	'斐济': 'F',
	'芬兰': 'F',
	'佛得角': 'F',
	'福克兰群岛': 'F',
	'冈比亚': 'G',
	'刚果（布）': 'G',
	'刚果（金）': 'G',
	'格陵兰': 'G',
	'格林纳达': 'G',
	'格鲁吉亚': 'G',
	'哥伦比亚': 'G',
	'哥斯达黎加': 'G',
	'关岛': 'G',
	'古巴': 'G',
	'圭亚那': 'G',
	'哈萨克斯坦': 'H',
	'海地': 'H',
	'韩国': 'H',
	'荷兰': 'H',
	'黑山': 'H',
	'洪都拉斯': 'H',
	'基里巴斯': 'J',
	'吉布提': 'J',
	'吉尔吉斯斯坦': 'J',
	'几内亚': 'J',
	'几内亚比绍': 'J',
	'加纳': 'J',
	'加蓬': 'J',
	'柬埔寨': 'J',
	'捷克共和国': 'J',
	'津巴布韦': 'J',
	'喀麦隆': 'K',
	'卡塔尔': 'K',
	'开曼群岛': 'K',
	'科科斯（基林）群岛': 'K',
	'科摩罗': 'K',
	'科特迪瓦': 'K',
	'科威特': 'K',
	'克罗地亚': 'K',
	'肯尼亚': 'K',
	'库克群岛': 'K',
	'拉脱维亚': 'L',
	'莱索托': 'L',
	'老挝': 'L',
	'黎巴嫩': 'L',
	'立陶宛': 'L',
	'利比里亚': 'L',
	'利比亚': 'L',
	'列支敦士登': 'L',
	'卢森堡': 'L',
	'卢旺达': 'L',
	'罗马尼亚': 'L',
	'马达加斯加': 'M',
	'马尔代夫': 'M',
	'马耳他': 'M',
	'马来西亚': 'M',
	'马拉维': 'M',
	'马里': 'M',
	'曼岛': 'M',
	'毛里求斯': 'M',
	'毛里塔尼亚': 'M',
	'马其顿': 'M',
	'马绍尔群岛': 'M',
	'马约特': 'M',
	'美属萨摩亚': 'M',
	'美属维京群岛': 'M',
	'蒙古': 'M',
	'蒙特塞拉特': 'M',
	'孟加拉国': 'M',
	'密克罗尼西亚': 'M',
	'缅甸': 'M',
	'摩尔多瓦': 'M',
	'摩洛哥': 'M',
	'摩纳哥': 'M',
	'莫桑比克': 'M',
	'墨西哥': 'M',
	'纳米比亚': 'N',
	'南非': 'N',
	'南极洲': 'N',
	'瑙鲁': 'N',
	'尼泊尔': 'N',
	'尼加拉瓜': 'N',
	'尼日尔': 'N',
	'尼日利亚': 'N',
	'纽埃': 'N',
	'挪威': 'N',
	'帕劳': 'P',
	'皮特凯恩群岛': 'P',
	'葡萄牙': 'P',
	'瑞典': 'R',
	'瑞士': 'R',
	'萨尔瓦多': 'S',
	'萨摩亚': 'S',
	'塞尔维亚': 'S',
	'塞拉利昂': 'S',
	'塞内加尔': 'S',
	'塞浦路斯': 'S',
	'塞舌尔': 'S',
	'沙特阿拉伯': 'S',
	'圣巴泰勒米': 'S',
	'圣诞岛': 'S',
	'圣多美和普林西比': 'S',
	'圣赫勒拿': 'S',
	'圣基茨和尼维斯': 'S',
	'圣卢西亚': 'S',
	'圣马力诺': 'S',
	'圣皮埃尔和密克隆群岛': 'S',
	'圣文森特和格林纳丁斯': 'S',
	'斯里兰卡': 'S',
	'斯洛伐克': 'S',
	'斯洛文尼亚': 'S',
	'斯威士兰': 'S',
	'苏丹': 'S',
	'苏里南': 'S',
	'所罗门群岛': 'S',
	'索马里': 'S',
	'塔吉克斯坦': 'T',
	'泰国': 'T',
	'坦桑尼亚': 'T',
	'汤加': 'T',
	'特克斯和凯科斯群岛': 'T',
	'特立尼达和多巴哥': 'T',
	'突尼斯': 'T',
	'图瓦卢': 'T',
	'土耳其': 'T',
	'土库曼斯坦': 'T',
	'托克劳': 'T',
	'瓦利斯和富图纳': 'W',
	'瓦努阿图': 'W',
	'危地马拉': 'W',
	'委内瑞拉': 'W',
	'文莱': 'W',
	'乌干达': 'W',
	'乌克兰': 'W',
	'乌拉圭': 'W',
	'乌兹别克斯坦': 'W',
	'西班牙': 'X',
	'希腊': 'X',
	'新加坡': 'X',
	'新喀里多尼亚': 'X',
	'新西兰': 'X',
	'匈牙利': 'X',
	'叙利亚': 'X',
	'牙买加': 'Y',
	'亚美尼亚': 'Y',
	'也门': 'Y',
	'伊拉克': 'Y',
	'伊朗': 'Y',
	'以色列': 'Y',
	'意大利': 'Y',
	'印度': 'Y',
	'印度尼西亚': 'Y',
	'英属维京群岛': 'Y',
	'约旦': 'Y',
	'越南': 'Y',
	'赞比亚': 'Z',
	'乍得': 'Z',
	'直布罗陀': 'Z',
	'智利': 'Z',
	'中非共和国': 'Z',
	'秘鲁': 'B'
};

// 获取中文国家名称的拼音首字母
export function getPinyinFirstLetter(countryName) {
	return pinyinFirstLetterMap[countryName] || '#';
}

// 常用区号代码列表
const hotAreaCodes = ['86', '852', '853', '886'];

// 判断是否为常用区号
function isHotAreaCode(code) {
	return hotAreaCodes.includes(code);
}

// 对本地区号数据进行去重处理
function deduplicateAreaCodeData(sourceData) {
	const processedCountryCode = new Set();
	const deduplicatedData = [];

	sourceData.forEach(item => {
		const { country, code } = item;
		const countryCodeKey = `${country}_${code}`;

		// 跳过已处理的国家+区号组合
		if (processedCountryCode.has(countryCodeKey)) {
			return;
		}

		processedCountryCode.add(countryCodeKey);
		deduplicatedData.push(item);
	});

	return deduplicatedData;
}

// 将本地数据转换为服务数据格式
export function convertToServiceFormat() {
	// 获取当前语言
	const currentLocale = i18n.locale;

	// 先对数据源进行去重处理
	const deduplicatedData = deduplicateAreaCodeData(nationAreaCode);

	// 分离常用区号和标准区号
	const hotAreaCodeList = [];
	const standardAreaCodeList = [];

	deduplicatedData.forEach(item => {
		if (isHotAreaCode(item.code)) {
			hotAreaCodeList.push(item);
		} else {
			standardAreaCodeList.push(item);
		}
	});

	// 处理常用区号
	const hotList = [];
	let idCounter = 1;

	hotAreaCodeList.forEach(item => {
		const { country, code } = item;
		const translatedCountryName = i18n.t(country);
		const areacode = `+${code}`;

		hotList.push({
			areacode,
			countryname: translatedCountryName,
			id: idCounter++,
			letter: '#',
			value: areacode + translatedCountryName,
			areaKey: `${'#'}_${areacode}`
		});
	});

	// 处理标准区号（按首字母分组）
	const letterGroups = {};

	standardAreaCodeList.forEach(item => {
		const { country, code } = item;
		const translatedCountryName = i18n.t(country);
		const areacode = `+${code}`;

		// 根据当前语言获取首字母
		let firstLetter;
		if (currentLocale === 'en') {
			firstLetter = translatedCountryName.charAt(0).toUpperCase();
			if (!/^[A-Z]$/.test(firstLetter)) {
				firstLetter = '#';
			}
		} else {
			firstLetter = getPinyinFirstLetter(country);
		}

		if (!letterGroups[firstLetter]) {
			letterGroups[firstLetter] = [];
		}

		letterGroups[firstLetter].push({
			areacode,
			countryname: translatedCountryName,
			id: idCounter++,
			letter: firstLetter,
			value: areacode + translatedCountryName,
			areaKey: `${firstLetter}_${areacode}`
		});
	});

	// 构建结果数组
	const result = [];

	// 1. 添加常用区号组（#）
	if (hotList.length > 0) {
		result.push({
			key: '#',
			countryAreaList: hotList.sort((a, b) => {
				// 常用区号按固定顺序：中国、香港、澳门、台湾
				const order = { '86': 1, '852': 2, '853': 3, '886': 4 };
				return (order[a.areacode.slice(1)] || 999) - (order[b.areacode.slice(1)] || 999);
			})
		});
	}

	// 2. 添加字母索引组
	const sortedLetters = Object.keys(letterGroups).sort();
	sortedLetters.forEach(letter => {
		result.push({
			key: letter,
			countryAreaList: letterGroups[letter]
		});
	});

	return result;
}
